export const headers = [
  {
    text: 'No',
    align: 'start',
    value: 'id',
    sortable: false,
    width: '10',
  },
  {
    text: 'Nama File',
    value: 'file_name',
    width: '150',
    align: 'start',
    sortable: false,
  },
  {
    text: 'Result',
    value: 'result',
    width: '150',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Create By',
    value: 'created_by_name',
    width: '150',
    align: 'center',
    sortable: false,
  },
  {
    text: 'Tanggal Upload',
    value: 'created_at',
    width: '150',
    align: 'start',
    sortable: false,
  },
  { text: 'Action', value: 'action', align: 'center', width: '20', sortable: false },
];

export const search =  {
  file_name: '',
  created_by: '',
  status: '',
  created_at: [],
};
